import React from 'react';
import { motion } from 'framer-motion';
import { FileText, UserCheck, FileSignature, Scale, AlertTriangle, Briefcase } from 'lucide-react';
const services = [{
  icon: <FileText size={24} strokeWidth={1.5} data-id="element-130" />,
  title: 'Оскарження рішень ВЛК',
  description: 'Юридичний супровід процедури оскарження висновків військово-лікарської комісії.',
  price: 'від 3000 грн'
}, {
  icon: <UserCheck size={24} strokeWidth={1.5} data-id="element-131" />,
  title: 'Супровід у ТЦК',
  description: 'Фізичний супровід адвоката при відвідуванні ТЦК. Захист від неправомірних дій.',
  price: 'від 4000 грн'
}, {
  icon: <FileSignature size={24} strokeWidth={1.5} data-id="element-132" />,
  title: 'Оформлення відстрочки',
  description: 'Аналіз підстав, збір документів та подання заяви до ТЦК.',
  price: 'від 2500 грн'
}, {
  icon: <Scale size={24} strokeWidth={1.5} data-id="element-133" />,
  title: 'Судовий захист',
  description: 'Представництво інтересів у судах. Оскарження незаконного призову.',
  price: 'Індивідуально'
}, {
  icon: <AlertTriangle size={24} strokeWidth={1.5} data-id="element-134" />,
  title: 'СЗЧ та Дезертирство',
  description: 'Захист військовослужбовців у кримінальних провадженнях.',
  price: 'Індивідуально'
}, {
  icon: <Briefcase size={24} strokeWidth={1.5} data-id="element-135" />,
  title: 'Звільнення зі служби',
  description: "Допомога у звільненні за станом здоров'я або сімейними обставинами.",
  price: 'від 3500 грн'
}];
export function Services() {
  return <section id="services" className="py-24 bg-surface" data-id="element-136">
      <div className="max-w-7xl mx-auto px-6" data-id="element-137">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-138">
          <h2 className="text-3xl md:text-4xl font-semibold" data-id="element-139">Наші послуги</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-140">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group bg-background rounded-3xl border border-border p-8 hover:border-primary/30 transition-colors duration-300 flex flex-col h-full" data-id="element-141">
              <div className="w-14 h-14 bg-surface rounded-2xl flex items-center justify-center text-primary mb-6 border border-border group-hover:scale-110 transition-transform duration-500" data-id="element-142">
                {service.icon}
              </div>

              <h3 className="text-xl font-semibold mb-3" data-id="element-143">{service.title}</h3>

              <p className="text-secondary text-sm leading-relaxed mb-8 flex-grow" data-id="element-144">
                {service.description}
              </p>

              <div className="mb-6 pt-5 border-t border-border" data-id="element-145">
                <div className="text-xs text-secondary uppercase tracking-wider mb-1 font-medium" data-id="element-146">
                  Вартість послуги
                </div>
                <div className="text-xl font-semibold text-primary" data-id="element-147">
                  {service.price}
                </div>
              </div>

              <a href="#contact" className="w-full py-3.5 bg-primary text-background rounded-xl font-medium hover:opacity-90 transition-opacity flex items-center justify-center text-sm" data-id="element-148">
                Безкоштовна консультація
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}